import { IWallet } from '@entities/wallets';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Paper, Typography, IconButton, Button, Divider } from '@mui/material';
import { useModal } from '@shared/components/Modal';

import { ChangeWalletPolicyModal } from './ChangeWalletPolicyModal';

interface IProps {
  selectedCount: number;
  onClear?: () => void;
  selectedIds?: string[];
  wallets?: IWallet[];
}

export const BulkActions = ({ selectedCount, onClear, selectedIds = [], wallets = [] }: IProps) => {
  const { openModal } = useModal();

  if (!selectedCount || selectedCount <= 0) return null;

  const handleChangePolicy = () => {
    openModal(
      <ChangeWalletPolicyModal selectedIds={selectedIds} wallets={wallets} onSuccess={onClear} />,
      'md',
    );
  };

  const itemsLabel = `${selectedCount} ${selectedCount === 1 ? 'Item' : 'Items'} selected`;

  return (
    <Paper
      elevation={6}
      sx={{
        position: 'fixed',
        left: '50%',
        transform: 'translateX(-50%)',
        bottom: 16,
        zIndex: theme => theme.zIndex.snackbar + 1,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: 2,
        py: 1,
        borderRadius: 2,
        width: 'fit-content',
        maxWidth: 'calc(100% - 32px)',
      }}
    >
      <IconButton aria-label='clear selection' onClick={onClear} disabled={!onClear}>
        <CloseIcon />
      </IconButton>

      <Typography variant='body1' sx={{ fontWeight: 500 }}>
        {itemsLabel}
      </Typography>

      <Divider orientation='vertical' flexItem />

      <Button
        id='bulk-change-wallet-type'
        variant='text'
        endIcon={<KeyboardArrowUpIcon />}
        onClick={handleChangePolicy}
      >
        Change wallet policy
      </Button>
    </Paper>
  );
};

export default BulkActions;
